import gql from 'graphql-tag';

export default gql`
query {
    getSiteRewardSetting{
     domain
     typeValue
     rewardType
     expiryDuration
     expiryUnit
     isEnabled
     onGroup
     groupId
     updatedAt
     applicableMenus
     accuralRule{
        value
        points
        isEnabled
        minOrderValue
        capValueType
        capValue
        noRedemptionOnDisc
      }
      redemptionRule{
       value
       points
       isEnabled
       minOrderValue
       capValueType
       capValue
       noRedemptionOnDisc
     }
    }
  }
`